function getClaireSemantic(domElement) {
  return domElement.getAttribute('data-claire-semantic') || '';
}

export default {
  getClaireSemantic,
};
